// extracted by mini-css-extract-plugin
export default {"content":"Card_content__6cdhQ"};